import React, {useEffect, useState} from 'react';
import {StyleSheet} from 'react-native';
import {Box, HStack, Heading, Pressable, Text, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useSalesmanContext} from '../../../../../../context/salesman';
import {IOrderItem} from '../../../../../../context/user/Types';
import InternalTemplate from '../../../../../../components/templates/internal';
import {StackParamList} from '../../../../../../navigators';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../../components/buttons';
import {DeleteIcon} from '../../../../../../components/icons';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanOrderShoppingCart'
>;

const SalesmanOrderShoppingCartScreen = ({navigation, route}: ScreenProps) => {
  const {
    setSalesmanProductToAdd,
    customerOrder: salesmanNewOrder,
    salesmanOrderItemCandidate,
    updateCandidateToShoppingCart,
    updateSalesmanNewOrder,
  } = useSalesmanContext();
  const [isSaving, setIsSaving] = useState(false);
  const [items, setItems] = useState([] as IOrderItem[]);

  useEffect(() => {
    if (salesmanNewOrder && salesmanNewOrder?.items) {
      setItems([...(salesmanNewOrder?.items as IOrderItem[])]);
      if (!isSaving && salesmanNewOrder?.items.length === 0) {
        handleOnProductsPress(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, salesmanNewOrder]);

  useEffect(() => {
    if (salesmanOrderItemCandidate) {
      updateCandidateToShoppingCart(null);
      setItems([...items, salesmanOrderItemCandidate]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesmanOrderItemCandidate]);

  const handleGoBack = () => {
    navigation.pop(1);
  };

  const handleOnProductsPress = (goProductSearch = false) => {
    setSalesmanProductToAdd(null);
    updateCandidateToShoppingCart(null);
    navigation.navigate(
      'SalesmanOrderAdd',
      goProductSearch ? route.params : undefined,
    );
  };

  const handleOnSavePress = () => {
    setIsSaving(true);
    if (salesmanNewOrder) {
      updateSalesmanNewOrder({
        ...salesmanNewOrder,
        items: [...items],
      });
    }
    navigation.pop(1);
  };

  const handleOnPressDelete = (position: number) => {
    const itemsRemoved = items.filter((obj, index) => position !== index);
    setItems([...itemsRemoved]);
  };

  return (
    <InternalTemplate
      title={'salesman-order-shopping-car-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <VStack paddingX={5}>
        <SecondaryButton
          label="salesman-order-shopping-car-products-button"
          onPress={handleOnProductsPress}
        />
        <Box mb="30" mt="30">
          {items &&
            items.map((item: IOrderItem, index: number) => (
              <HStack key={`item-${index}`} style={styles.itemBox}>
                <Pressable onPress={() => handleOnPressDelete(index)}>
                  <DeleteIcon width={40} />
                </Pressable>
                <HStack width={'90%'}>
                  <VStack style={styles.itemInfoBox} width={'70%'}>
                    <Heading style={styles.itemTitle}>
                      {item.product.title}
                    </Heading>
                    <Text style={styles.itemSummary}>
                      {item.product.summary}
                    </Text>
                  </VStack>
                  <VStack
                    style={styles.itemCountBox}
                    justifyItems={'flex-end'}
                    width={'30%'}>
                    <Heading style={styles.itemUnit}>{item.unit.title}</Heading>
                    <Text style={styles.itemCount}>{item.count}</Text>
                  </VStack>
                </HStack>
              </HStack>
            ))}
        </Box>
        <PrimaryButton
          label="salesman-order-shopping-car-save-button"
          onPress={handleOnSavePress}
        />
      </VStack>
    </InternalTemplate>
  );
};
export default SalesmanOrderShoppingCartScreen;

const styles = StyleSheet.create({
  itemBox: {
    borderColor: '#0000001e',
    borderBottomWidth: 1,
    width: '100%',
    paddingBottom: 10,
    paddingTop: 10,
  },
  itemInfoBox: {
    paddingTop: 10,
    paddingLeft: 5,
  },
  itemCountBox: {paddingTop: 10},
  itemTitle: {
    fontSize: 16,
    textAlign: 'left',
    paddingLeft: 5,
  },
  itemSummary: {
    color: '#00000099',
    textAlign: 'left',
    paddingLeft: 5,
  },
  itemUnit: {
    fontSize: 10,
    color: '#000000DE',
    textAlign: 'right',
    paddingRight: 2,
  },
  itemCount: {
    color: '#000000DE',
    textAlign: 'right',
    paddingRight: 2,
  },
});
